module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/cold-calls-files/cold-calls-files.component.css
// module id = ./src/app/cold-calls-files/cold-calls-files.component.css
// module chunks = main